module.exports = __webpack_public_path__ + "img/profile2.b1eac9ad.jpg";